module.exports = __webpack_public_path__ + "img/prize-bg.755c490.svg";